//
// Copyright (c) 2011-2026 by Curalate, Inc.
//

import { FeatureNames } from '@bvengineering/curalate-features';
import { IUrlRouterProvider } from 'angular-ui-router';

import { ambassadorStates } from '@campaigns/routes/ambassadorRoutes';
import { contentSourceStates } from '@campaigns/routes/contentSourceRoutes';
import { creatorsStates } from '@campaigns/routes/creatorsRoutes';
import { samplingStates } from '@campaigns/routes/samplingRoutes';
import { CampaignsStateFactory } from '@campaigns/routes/stateFactory';

import {
  componentNameToTemplate,
  hasFeature,
  lazyLoadModule,
} from 'app/initialization/routing/stateHelpers';

export const routingRules = (urlRouterProvider: IUrlRouterProvider) => {
  const isCreatorCampaignsEnabled = hasFeature(FeatureNames.CreatorCampaigns);
  // TODO: PD-309661 - Remove feature flag check once Vibe Ambassadors is fully released
  const isVibeAmbassadorsEnabled = hasFeature(FeatureNames.VibeAmbassadors);

  // TODO: PD-329868 - Remove feature flag check once Campaigns Custom Reporting Refresh is fully released
  const isCampaignsCustomReportingRefreshEnabled = hasFeature(
    FeatureNames.CampaignsCustomReportingRefresh,
  );

  if (!isCreatorCampaignsEnabled) {
    urlRouterProvider.when('/campaigns/creators', '/campaigns/sampling');
    urlRouterProvider.when(/\/campaigns\/creators\/.*/, '/campaigns/sampling');
  }

  if (!isVibeAmbassadorsEnabled) {
    urlRouterProvider.when(
      /\/campaigns\/ambassadors\/.*/,
      '/campaigns/sampling',
    );
  }

  if (!isCampaignsCustomReportingRefreshEnabled) {
    urlRouterProvider.when('/campaigns/all', '/campaigns/sampling');
    urlRouterProvider.when(/\/campaigns\/all\/.*/, '/campaigns/sampling');
  }
};

export const states = {
  campaigns: CampaignsStateFactory({
    url: '/campaigns',
    template: componentNameToTemplate('campaignsPage'),
    redirectTo: 'campaigns.sampling',
    resolve: {
      ...lazyLoadModule(
        'curalate.campaigns',
        () => import('@campaigns/CampaignsApp'),
      ),
    },
  }),

  'campaigns.all': CampaignsStateFactory({
    data: {
      title: 'Campaigns',
    },
    url: '/all',
    views: {
      main: {
        template: componentNameToTemplate('allCampaignsPage'),
      },
    },
  }),

  'campaigns.purchase-options': CampaignsStateFactory({
    data: {
      title: 'Campaigns: Purchase Options',
    },
    url: '/purchase-options',
    views: {
      main: {
        template: componentNameToTemplate('purchaseOptionsPage'),
      },
    },
  }),

  ...samplingStates,
  ...creatorsStates,
  ...contentSourceStates,
  ...ambassadorStates,
};
